import { cn } from '@/lib/utils'

type Props = {
  rating: number
  className?: string
  /** Pixel size for each star */
  size?: 'sm' | 'md'
  /** Higher contrast on primary / dark panels */
  variant?: 'default' | 'onDark'
}

export function StarRating({ rating, className, size = 'sm', variant = 'default' }: Props) {
  const full = Math.min(5, Math.max(0, Math.round(rating)))
  const dim = size === 'md' ? 'h-[18px] w-[18px]' : 'h-4 w-4'
  const filled = variant === 'onDark' ? 'text-amber-200' : 'text-amber-500'
  const empty = variant === 'onDark' ? 'text-on-primary/30' : 'text-hairline'

  return (
    <div
      className={cn('flex items-center gap-0.5', className)}
      role="img"
      aria-label={`${rating} out of 5 stars`}
    >
      {Array.from({ length: 5 }, (_, i) => (
        <svg
          key={i}
          viewBox="0 0 24 24"
          className={cn(dim, i < full ? filled : empty)}
          aria-hidden
        >
          <path
            fill="currentColor"
            d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
          />
        </svg>
      ))}
    </div>
  )
}
